import { AxiosError } from 'axios';
import BigNumber from 'bignumber.js';
import { toast } from 'react-toastify';

export const handleRequestErrors = (error: AxiosError, defaultMessage?: string) => {
  let useMessage = '';

  if (error && error.response && error.response.status.toString().startsWith('4')) {
    const errors = (error.response as any).data.errors;
    useMessage = (error.response as any).data.message || (errors && errors[0].message) || defaultMessage || 'An unexpected error occurred.';
  }

  toast.error(useMessage);
};

export const normaliseAmount = (decimals: number, value: number): number => {
  return Number(Math.floor(parseFloat(value + 'e' + decimals)) + 'e-' + decimals);
};

export const formatCurrency = (amount: number | string, currency: string, valueOnly = false, decimals = 2): string => {
  amount = normaliseAmount(decimals, Number(new BigNumber(amount).toFixed(decimals, BigNumber.ROUND_DOWN)));

  const value = parseFloat(Number(amount).toFixed(decimals));

  if (valueOnly) {
    return value.toString();
  }

  try {
    return amount.toLocaleString('en-US', { style: 'currency', currency, maximumFractionDigits: decimals });
  } catch {
    return value.toString();
  }
};
